var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90455 4C9.67308 4 9.48545 4.18851 9.48545 4.42105V5.85084C8.95165 6.09157 8.45489 6.40039 8.00611 6.7663L6.7242 6.02274C6.52375 5.90647 6.26743 5.97547 6.1517 6.17685L4.05622 9.82329C3.94049 10.0247 4.00917 10.2822 4.20962 10.3985L5.57124 11.1883C5.53943 11.4544 5.52306 11.7253 5.52306 12C5.52306 12.2748 5.53943 12.5458 5.57126 12.812L4.20971 13.6017C4.00926 13.718 3.94058 13.9755 4.05631 14.1769L6.15179 17.8233C6.26752 18.0247 6.52384 18.0937 6.72429 17.9774L8.00623 17.2339C8.45498 17.5997 8.9517 17.9085 9.48545 18.1492V19.579C9.48545 19.8115 9.67308 20.0001 9.90455 20.0001H14.0955C14.327 20.0001 14.5146 19.8115 14.5146 19.579V18.3353C15.1447 18.1057 15.7308 17.784 16.2568 17.3864L17.2758 17.9774C17.4762 18.0937 17.7325 18.0247 17.8483 17.8233L19.9438 14.1769C20.0595 13.9755 19.9908 13.718 19.7904 13.6017L18.852 13.0574C18.9061 12.713 18.9342 12.3598 18.9342 12C18.9342 11.6403 18.9061 11.2872 18.8521 10.9428L19.7904 10.3985C19.9909 10.2822 20.0596 10.0247 19.9438 9.82329L17.8484 6.17685C17.7326 5.97547 17.4763 5.90647 17.2759 6.02274L16.2569 6.61378C15.7309 6.21608 15.1447 5.89433 14.5146 5.66478V4.42105C14.5146 4.18851 14.327 4 14.0955 4H9.90455Z",
    stroke: "#444444",
    strokeWidth: 1.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.25,
    stroke: "#444444",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.bf47e69a195315e3f7e9159aed4ee1f5.svg";
export { ForwardRef as ReactComponent };